<template>
    <div class="min-h-screen bg-gray-50">
        <!-- Navigation Breadcrumb -->
        <BreadcrumbNavigation :breadcrumbs="breadcrumbs"/>
        <div :style="{marginBottom: eventData.required_enrolled && (!enrolledUsered) ? '100px' : '10px'}"
             class="max-w-7xl mx-auto  px-4 sm:px-6 lg:px-8 py-12">
            <!-- Contenu principal -->
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
                <!-- Galerie d'images -->
                <ImageGallery
                    :images="eventData.image ? asset('storage/'+eventData.image) : asset('images/event.jpg')"
                    :alt="eventData.title"
                />

                <!-- Informations de l'événement -->
                <EventInfo
                    :event-data="eventData"
                    :organizer="organizer"
                    @share="shareEvent"
                />
            </div>
            <!-- Description -->
            <div class="prose prose-lg max-w-none text-justify" v-html="html()">

            </div>

            <div style="display: flex;flex-direction: row !important;gap: 15px;flex-wrap: wrap"
                 v-if="eventData.appointments?.length > 0">
                <EventShedulseCard
                    v-for="item in eventData.appointments"
                    :title="item.title"
                    :date="new Date(item.date)"
                    :location="item.location"
                    @click=""
                />
            </div>
            <div v-else class="w-[100%] bg-white border border-[#e2e2e2] py-5  mt-10  cursor-pointer">
                <!-- En-tête avec titre -->
                <div class="px-5">
                    <div class="flex items-start gap-2">
                        <div class="text-amber-700 mt-0.5 flex-shrink-0">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                 stroke-width="2">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                                <line x1="16" y1="2" x2="16" y2="6"/>
                                <line x1="8" y1="2" x2="8" y2="6"/>
                                <line x1="3" y1="10" x2="21" y2="10"/>
                            </svg>
                        </div>
                        <span class="text-sm text-gray-600 text-2xl leading-relaxed">{{
                                formattedDate(eventData.start_date)
                            }}</span>
                        <span> - </span>
                        <span class="text-sm text-gray-600 text-2xl leading-relaxed">{{
                                formattedDate(eventData.end_date)
                            }}</span>
                    </div>
                </div>
            </div>

            <UpcomingEvents v-if="upcomingEvent.length > 0" :upcoming-event="upcomingEvent"></UpcomingEvents>
        </div>
    </div>
    <!-- Footer Banner Fixe -->
    <div v-if="eventData.required_enrolled && (!enrolledUsered) && today >= new Date(eventData.registration_deadline)"
         class="fixed mt-10 bottom-0 left-0 w-full bg-pattern-svg text-white px-6 py-4 flex justify-between z-10 items-center shadow-2xl">

        <!-- Bloc texte -->
        <div>
            <h2 class="text-xl font-bold">{{ eventData.title }}</h2>
            <p class="text-sm text-gray-200">Inscription valable jusqu’au <span
                class="font-semibold">{{ formattedDate(eventData.date_enrolled) }}</span></p>
        </div>

        <!-- Bouton inscription -->
        <a href="" @click.prevent="enrolling"
           class="bg-white cursor-pointer text-[#2A4493] px-5 py-2 rounded-xl font-medium shadow hover:bg-gray-100 transition">
            S'inscrire
        </a>
    </div>

    <div
        id="modal" style="background-color: rgba(0,0,0,0.55)"
        class="hidden fixed inset-0 flex items-center justify-center z-50">

        <div class="bg-white w-125 rounded-2xl shadow-lg p-6 relative">

            <!-- Bouton fermer -->
            <button
                id="closeModal"
                class="absolute cursor-pointer top-3 right-3 text-gray-500 hover:text-gray-700"
                @click.prevent="closeModal">
                x
            </button>
            <form @submit.prevent="submitAuth" method="post" ref="formRef" v-if="is_user">
                <!-- Contenu -->
                <h2 class="text-xl font-semibold mb-4">Connexion</h2>
                <!-- Email -->
                <div class="mb-5">
                    <label for="email" class="block text-sm font-medium text-gray-600 mb-1">Adresse email</label>
                    <input
                        type="email"
                        id="email"
                        required
                        v-model="formulaireConnexion.email"
                        placeholder="exemple@email.com"
                        class="w-full px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#2A4493] focus:outline-none shadow-sm placeholder-gray-400"
                    />
                </div>

                <!-- Mot de passe -->
                <div class="mb-5">
                    <label for="password" class="block text-sm font-medium text-gray-600 mb-1">Mot de passe</label>
                    <input
                        type="password"
                        id="password"
                        required
                        v-model="formulaireConnexion.password"
                        placeholder="••••••••"
                        class="w-full px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#2A4493] focus:outline-none shadow-sm placeholder-gray-400"
                    />
                </div>

                <div class="flex justify-end gap-3">
                    <button id="closeModal2" @click.prevent="closeModal"
                            class="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 cursor-pointer">
                        Annuler
                    </button>
                    <button
                        type="submit"
                        class="w-full bg-[#2A4493] text-white py-2 rounded-xl hover:bg-[#2A4493] cursor-pointer transition shadow-md font-medium">
                        Se connecter
                    </button>
                </div>
            </form>
            <form @submit.prevent="enrolledWithoutAuth" method="post" ref="formRef" v-else>
                <!-- Contenu -->
                <h2 class="text-xl font-semibold mb-4">Inscrivez-vous</h2>
                <!-- Email -->
                <div class="mb-5">
                    <label for="name" class="block text-sm font-medium text-gray-600 mb-1">Nom</label>
                    <input
                        type="text"
                        id="name"
                        required
                        placeholder="Veuillez saisir votre nom"
                        v-model="formulaireInscription.first_name"
                        class="w-full px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#2A4493] focus:outline-none shadow-sm placeholder-gray-400"
                    />
                </div>

                <!-- Mot de passe -->
                <div class="mb-5">
                    <label for="last_name" class="block text-sm font-medium text-gray-600 mb-1">Prénom</label>
                    <input
                        type="text"
                        id="last_name"
                        required
                        v-model="formulaireInscription.last_name"
                        placeholder="Veuillez saisir votre prénom"
                        class="w-full px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#2A4493] focus:outline-none shadow-sm placeholder-gray-400"
                    />
                </div>

                <div class="flex justify-end gap-3">
                    <button id="closeModal2" @click.prevent="closeModal"
                            class="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 cursor-pointer">
                        Annuler
                    </button>
                    <button
                        type="submit"
                        class="w-full bg-[#2A4493] text-white py-2 rounded-xl hover:bg-[#2A4493] cursor-pointer transition shadow-md font-medium">
                        S'inscrire
                    </button>
                </div>
            </form>

        </div>
    </div>
</template>

<script setup>
import {ref, reactive} from 'vue'
import BreadcrumbNavigation from "@/vue/Public/event/detail/BreadcrumbNavigation.vue";
import ImageGallery from "@/vue/Public/event/detail/ImageGallery.vue";
import EventInfo from "@/vue/Public/event/detail/EventInfo.vue";
import UpcomingEvents from "@/vue/Public/event/detail/UpcomingEvents.vue";
import {asset, getBearerToken} from "@/helper.js";
import EventShedulseCard from "@/vue/Public/event/detail/EventShedulseCard.vue";
import {NotificationToast} from "@/utils/notification.js";

const props = defineProps({
    eventData: {
        type: [Object, null],
        default: null
    },
    upcomingEvent: {
        type: [Array, Object, null],
        default: []
    },
    organizer: {
        type: String,
        default: ''
    },
    auth: {
        type: [Object, null],
        default: null
    },
    enrolledUser: {
        type: [Boolean, null,Number],
        default: false
    },
})
const today = new Date();
const barearToken = ref(null)

const enrolledUsered = ref(props.enrolledUser)

// Données réactives
const breadcrumbs = ref([
    {label: 'Accueil', href: '/'},
    {label: 'Nos Événements', href: '/events'},
    {label: props.eventData.title, href: null, current: true}
])

const is_user = ref(false)
const html = () => {
    return props.eventData.description
}

const shareEvent = () => {
    if (navigator.share) {
        navigator.share({
            title: props.eventData.title,
            text: props.eventData.description,
            url: window.location.href
        })
    } else {
        // Fallback pour les navigateurs qui ne supportent pas Web Share API
        navigator.clipboard.writeText(window.location.href)
        alert('Lien copié dans le presse-papier!')
    }
}
const formRef = ref(null)

const formattedDate = (dateString) => {
    if (!dateString) return ''

    const date = new Date(dateString)
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }

    return date.toLocaleDateString('fr-FR', options)
}
const formulaireConnexion = reactive({
    email: null,
    password: null
})
const formulaireInscription = reactive({
    first_name: null,
    last_name: null
})


const enrollWhenConnexion = (token) => {
    $.confirm({
        icon: 'fa fa-question',
        title: 'Confirmation',
        content: 'Voulez-vous vraiment vous inscrire',
        useBootstrap: false,
        boxWidth: '500px',
        // autoClose: 'Annuler|10000',
        theme: 'modern',
        closeIcon: true,
        animation: 'scale',
        type: 'red',
        buttons: {
            btn: {
                text: 'Confirmer',
                btnClass: 'btn-red',
                action: function () {
                    axios.post('/api/enrollment/enroll/' + props.eventData.id, {}, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }).then(response => {
                        if (response.status === 200) {
                            NotificationToast(response.data.type, response.data.message)
                            enrolledUsered.value = response.data.is_enrolled
                        }
                    }).catch(error => {
                        console.error(error)
                        NotificationToast('error', error.response.data.message)
                    })
                }
            },
            Annuler: function () {
            }
        }
    });
}


const enrolling = () => {
    if (props.auth || barearToken.value) {
        enrollWhenConnexion(getBearerToken())
    } else {
        $.confirm({
            icon: 'fa fa-question',
            title: 'Confirmation',
            content: 'Avez vous un compte',
            useBootstrap: false,
            boxWidth: '500px',
            // autoClose: 'Annuler|10000',
            theme: 'modern',
            closeIcon: true,
            animation: 'scale',
            type: 'blue',
            buttons: {
                btn: {
                    text: 'Oui',
                    btnClass: 'btn-blue',
                    action: function () {
                        const modal = document.getElementById("modal");
                        is_user.value = true
                        modal.classList.remove("hidden")
                    }
                },
                Non: function () {
                    const modal = document.getElementById("modal");
                    is_user.value = false
                    modal.classList.remove("hidden")
                }
            }
        });
    }

}
const closeModal = () => {
    const modal = document.getElementById("modal");
    modal.classList.add("hidden")
}
const submitAuth = () => {
    axios.post('/enrollment/login/' + props.eventData.id, formulaireConnexion, {withCredentials: true}).then(response => {
        if (response.data.status === 200) {
            closeModal()
            barearToken.value = response.data.token;
        }
        NotificationToast(response.data.type, response.data.message);
        enrolledUsered.value = response.data.enrolled;
        if (!enrolledUsered.value) {
            enrollWhenConnexion(barearToken.value)
        }

    }).catch(error => {
        NotificationToast('error', error.response.data.message);
        console.error(error)
    })
}

const enrolledWithoutAuth = () => {
    if (!formulaireInscription.last_name || !formulaireInscription.first_name) return NotificationToast('error', 'Veuillez renseigner tous les champs');
    axios.post('/api/enrollment/enroll-without-login/' + props.eventData.id, formulaireInscription,).then(response => {
        if (response.status === 200) {
            closeModal()
            enrolledUsered.value = true
            NotificationToast(response.data.type, response.data.message);
        }

    }).catch(error => {
        NotificationToast('error', error.response.data.message);
    })
}
</script>

